/**
 * @generated SignedSource<<06952a83222970f40d7f0b0dc7e558de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MeetingRecordingStatus = "CALL_ENDED" | "ERROR" | "IN_WAITING_ROOM" | "JOINED_CALL" | "JOIN_REQUEST_DENIED" | "KICKED_OUT" | "LEFT_DUE_TO_INACTIVITY" | "PAUSED" | "READY" | "RECORDING" | "RECORDING_DONE" | "RECORDING_PERMISSION_DENIED" | "SCHEDULED" | "TIME_OUT_EXCEEDED_IN_CALL_NOT_RECORDING" | "TIME_OUT_EXCEEDED_RECORDING_PERMISSION_DENIED" | "TIME_OUT_EXCEEDED_WAITING_ROOM" | "TRANSCRIPTION_DONE" | "UNKNOWN" | "UNRECOVERABLE" | "ZOOM_BOT_IN_WAITING_ROOM" | "ZOOM_HOST_NOT_PRESENT" | "ZOOM_LOCAL_RECORDING_DISABLED" | "ZOOM_LOCAL_RECORDING_GRANT_NOT_SUPPORTED" | "ZOOM_LOCAL_RECORDING_REQUEST_DENIED_BY_HOST" | "ZOOM_LOCAL_RECORDING_REQUEST_DISABLED" | "ZOOM_LOCAL_RECORDING_REQUEST_DISABLED_BY_HOST";
import { FragmentRefs } from "relay-runtime";
export type utils_useAutoRefetchMeetingRecording_note$data = {
  readonly finished: boolean;
  readonly groupName: string;
  readonly id: string;
  readonly meetingRecordings: ReadonlyArray<{
    readonly id: string;
    readonly meetingCallStart: string;
    readonly status: MeetingRecordingStatus;
  }> | null;
  readonly " $fragmentType": "utils_useAutoRefetchMeetingRecording_note";
};
export type utils_useAutoRefetchMeetingRecording_note$key = {
  readonly " $data"?: utils_useAutoRefetchMeetingRecording_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_useAutoRefetchMeetingRecording_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "utils_useAutoRefetchMeetingRecording_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finished",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingCallStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "0d696807d7551051db1804fdd2c0bf98";

export default node;
